import { T }    from 'defa-object';
import template from './accessoryView.jst.html'
/**
 * defa.views.Accessory
 * A description.
 * @version 0.1
 */
import View     from 'scripts/poppet/view';
const selectors = {
	showAccessory  : '[data-click=click-accessory]',
	container      : '[data-region=container]',
	buttonCancel   : '[data-click=cancel]',
};

const AccessoryView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	template  : template,
	className : 'unit-accessory',

	regions   : {
		container: selectors.container
	},
	
	ui: {
		show  : selectors.showAccessory,
	},
	
	events: {
		'click    @ui.show': 'onClickShow',
	},
	
	templateContext: function () {
		return {
			datetime : this.model.getDateTime(),
			getId : this.model.getId(),
		};
	},
	
	onClickShow: function( event ) {
		event.preventDefault();
		this._showAccessory();
	},
	
	_showAccessory: function() {
		this.trigger('show:accessory', this.model.get('id'));
	},
	

} );

export default AccessoryView;